import { createSlice } from '@reduxjs/toolkit';
import {
  deleteDocumentBuilder,
  getClientContractsBuilder,
  getDocumentByIdBuilder,
  postClientContractBuilder,
  editDocumentBuilder,
  setClientWeddingDateBuilder,
  acceptClientDeleteRequestBuilder,
  sendDeleteRequestToClientBuilder,
  rejectContractDeleteRequestBuilder,
} from './builder';

const initialState = {
  fetchClientContractsPending: false,
  postClientContractPending: false,
  getDocumentByIdPending: false,
  deleteDocumentPending: false,
  editDocumentPending: false,
  setClientWeddingDatePending: false,
  acceptClientDeleteRequestPending: false,
  sendDeleteRequestToClientPending: false,
  rejectContractDeleteRequestPending: false,

  selectedClientContracts: {
    data: [],
    maxReached: false,
    page: 1,
    total: 0,
  },

  selectedContract: {},
};
export const weddingSlice = createSlice({
  name: 'weddingInfo',
  initialState,
  reducers: {
    resetSelectedContract(state) {
      state.selectedContract = {};
    },
  },
  extraReducers: builder => {
    getClientContractsBuilder(builder);
    postClientContractBuilder(builder);
    getDocumentByIdBuilder(builder);
    deleteDocumentBuilder(builder);
    editDocumentBuilder(builder);
    setClientWeddingDateBuilder(builder);
    acceptClientDeleteRequestBuilder(builder);
    sendDeleteRequestToClientBuilder(builder);
    rejectContractDeleteRequestBuilder(builder);

    builder.addCase('logout', () => initialState);
  },
});

export const selectClientContracts = state => state.weddingInfo.selectedClientContracts;
export const selectFetchClientContractsPending = state => state.weddingInfo.fetchClientContractsPending;
export const selectPostClientContractPending = state => state.weddingInfo.postClientContractPending;
export const selectSelectedContract = state => state.weddingInfo.selectedContract;
export const selectGetDocumentByIdPending = state => state.weddingInfo.getDocumentByIdPending;
export const selectDeleteDocumentPending = state => state.weddingInfo.deleteDocumentPending;
export const selectEditDocumentPending = state => state.weddingInfo.editDocumentPending;
export const selectSetClientWeddingDatePending = state => state.weddingInfo.setClientWeddingDatePending;
export const selectAcceptClientDeleteRequestPending = state => state.weddingInfo.acceptClientDeleteRequestPending;
export const selectSendDeleteRequestToClientPending = state => state.weddingInfo.sendDeleteRequestToClientPending;
export const selectRejectContractDeleteRequestPending = state => state.weddingInfo.rejectContractDeleteRequestPending;

export const { resetSelectedContract } = weddingSlice.actions;

export default weddingSlice.reducer;
